export default __webpack_public_path__ + "static/media/spoc_man.05095c93.svg";